import React from 'react';
import {Link} from 'react-router-dom';

import {Layouts} from '@components';
import {Props} from './types';
import paths from '@paths';

import './index.scss';

const Thank: React.FC<Props> = props => {
  return (
    <div className="a__thank">
      <Layouts.Header.Before
        history={props.history}
        location={props.location}
        match={props.match}
      />
      <div className="w__message">
        <div className="b__title">認証コードをお送りしました</div>
        <div className="b__message">
          入力されたメールアドレス宛に新規登録用の認証コードをお送りしました。
          <br />
          認証コード入力画面から認証コードを入力して、パスワードリセットを完了させてください。
        </div>
        <Link to={paths.signIn.main} className="b__link">
          ログインページに戻る
        </Link>
      </div>
      <Layouts.Footer.Main />
    </div>
  );
};
export default Thank;
